<template>
    <div class="page-loading modal fade show" v-show="showLoading">
        <div class="page-loading__loader"></div>
        <div class="page-loading__text py-3">
            {{ message }}
        </div>
    </div>
</template>

<script>
    import mixinPubSub from './mixinPubSub'

    export default {
        mixins: [ mixinPubSub ],
        data() {
            return {
                showLoading: false,
                message: ''
            }
        },
        mounted() {
            this.onPageLoading(( showLoading, message ) => {
                this.message = message;
                this.showLoading = showLoading;
            });
        }
    }
</script>
